import { ColorDynamic } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';

export const SuperPayRequestShipperGradientBox = styled(Box)`
  background:
    linear-gradient(${ColorDynamic.White}, ${ColorDynamic.White}) padding-box,
    linear-gradient(
        to right,
        ${ColorDynamic.Yellow300} 0%,
        ${ColorDynamic.Purple500} 28.67%,
        ${ColorDynamic.Teal500} 100.59%
      )
      border-box;
  border: 1.5px solid transparent;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 52px;
  padding: 15px;
`;
